"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.gapSizes = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * @enum {string}
 * @alias Stack.gapSizes
 * @desc Different sizes of gap
 */
var gapSizes = {
  /** ZERO */
  ZERO: "ZERO",

  /** XS */
  XS: "XS",

  /** SM */
  SM: "SM",

  /** MD */
  MD: "MD",

  /** LG */
  LG: "LG",

  /** XL */
  XL: "XL",

  /** XX */
  XX: "XX"
};
/**
* @class Stack
* @desc A container that spaces its children in a column
*
* @param {string} [data-id=stack]
*     The data-id of the component
* @param {string} [className]
*     Class name(s) to add to the top-level container/div
* @param {Stack.gapSizes} [gap="MD"]
*     Space items in the stack by ZERO, XS, SM, MD, LG, XL, or XX
* @param {boolean} [wrappers=false]
*     When true, use wrapper elements around items.
*/

exports.gapSizes = gapSizes;

var Stack = function Stack(_ref) {
  var _context;

  var children = _ref.children,
      className = _ref.className,
      dataId = _ref["data-id"],
      gap = _ref.gap,
      wrappers = _ref.wrappers;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("stack", className, "stack--".concat(gap.toLowerCase())),
    "data-id": dataId
  }, wrappers ? (0, _map.default)(_context = _react.default.Children).call(_context, children, function (child) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "stack__wrapper"
    }, child);
  }) : children);
};

Stack.propTypes = {
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  gap: _propTypes.default.oneOf((0, _values.default)(gapSizes))
};
Stack.defaultProps = {
  "data-id": "stack",
  gap: "MD"
};
var _default = Stack;
exports.default = _default;